export default __webpack_public_path__ + "e31bbfba048b7ee05f6721b74943b71c.png";